/* Knockout Couture - abanico de tarjetas.
   - Sin GSAP (o si falla el CDN) las tarjetas quedan como fila deslizable estatica, todas visibles.
   - Una instancia por seccion, con limpieza. Escucha los eventos del editor de temas. */
(function () {
  if (window.KnockoutAbanico) return;
  var GSAP_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ROT = 21, SMIN = 0.78;
  var gsapPromise = null;
  var instances = new WeakMap();

  function loadGsap() {
    if (window.gsap) return Promise.resolve(window.gsap);
    if (gsapPromise) return gsapPromise;
    gsapPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = GSAP_SRC; s.async = true;
      s.onload = function () { window.gsap ? resolve(window.gsap) : reject(new Error('gsap')); };
      s.onerror = function () { reject(new Error('gsap-cdn')); };
      document.head.appendChild(s);
      setTimeout(function () { if (!window.gsap) reject(new Error('gsap-timeout')); }, 6000);
    });
    return gsapPromise;
  }

  function wMult(w) { return w < 480 ? 0.28 : w < 640 ? 0.38 : w < 768 ? 0.5 : w < 1024 ? 0.75 : 1; }

  function Fan(root) {
    var self = this;
    this.root = root;
    this.ac = new AbortController();
    this.sig = { signal: this.ac.signal };
    this.stage = root.querySelector('[data-stage]');
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-kfan-card]'));
    this.ui = root.querySelector('[data-ui]');
    this.dots = root.querySelector('[data-dots]');
    this.count = root.querySelector('[data-count]');
    this.live = root.querySelector('[data-live]');
    this.N = this.cards.length;
    this.offset = 0; this.hovered = -1; this.geo = {};
    this.moved = false; this.down = false; this.started = false; this.active = false;
    this.logo = root.getAttribute('data-logo') || '';
    this.mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.mqHover = window.matchMedia('(hover:hover) and (pointer:fine)');
    this.coarse = window.matchMedia('(pointer:coarse)').matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0;   // tactil: transiciones cortas, sin elastic
    this.cards.forEach(function (a) {
      var img = a.querySelector('img');
      if (!img) return;
      var fail = function () {
        a.classList.add('kfan__card--broken');
        if (self.logo) { var l = new Image(); l.className = 'kfan__ph'; l.alt = ''; l.src = self.logo; img.replaceWith(l); } else { img.remove(); }
      };
      img.addEventListener('error', fail, { once: true });
      if (img.complete && img.naturalWidth === 0 && img.currentSrc) fail();
    });
    // GSAP (CDN) se pide ya al inicializar la seccion (antes: al acercarse), para que el primer gesto ya tenga animacion
    var go = function () { if (self.destroyed || self.gsapStarted) return; self.gsapStarted = true; loadGsap().then(function () { if (!self.destroyed) self.enable(); }).catch(function () { /* se queda la fila deslizable */ }); };
    go();
  }

  Fan.prototype.reduce = function () { return this.mqReduce.matches; };
  Fan.prototype.canHover = function () { return this.mqHover.matches && !this.reduce(); };

  Fan.prototype.measure = function () {
    var vw = this.root.clientWidth || window.innerWidth, vh = window.innerHeight, N = this.N;   // ancho REAL del contenedor
    var w = vw < 480 ? 164 : vw < 640 ? 170 : 320 * wMult(vw);
    if (vw >= 1024 && N >= 9) w = Math.min(w, 280);
    w = Math.min(w, vh * 0.7 * 0.75);
    var vis = Math.min(vw < 640 ? 5 : vw < 1024 ? 7 : 9, N); if (vis > 1 && vis % 2 === 0) vis -= 1;   // siempre impar: una sola tarjeta central
    var step = w * (vw < 640 ? 0.37 : 0.5);
    if (vw >= 640 && vis > 1) step = Math.min(step, (vw - w) / (vis - 1) * 0.95);
    this.geo = { w: w, h: Math.round(w * 4 / 3), vis: vis, step: step };
    var hWant = Math.round(this.geo.h * 1.25 + 24);
    if (Math.abs(this.stage.getBoundingClientRect().height - hWant) > 1.5) this.stage.style.height = hWant + 'px';
    this.root.classList.toggle('kfan--narrow', vw < 640);   // en estrecho solo se rotula la tarjeta central (las laterales asoman ~60 px)
    var self = this;
    this.cards.forEach(function (a) {
      var r = a.getBoundingClientRect();
      if (Math.abs(r.width - w) > 0.6) a.style.width = w + 'px';
      if (Math.abs(r.height - self.geo.h) > 0.6) a.style.height = self.geo.h + 'px';
    });
    // posicion de cada tarjeta en el flujo (fila estatica): el abanico se logra SOLO con transform/opacity
    this.stage.scrollLeft = 0;
    this.baseLeft = this.cards.map(function (a) { return a.offsetLeft; });
    this.baseTop = this.cards.length ? this.cards[0].offsetTop : 0;
    this.stageW = this.stage.clientWidth;
  };

  Fan.prototype.slotOf = function (i) { return ((i - this.offset) % this.N + this.N) % this.N; };

  Fan.prototype.target = function (slot) {
    var g = this.geo, v = g.vis, c = (v - 1) / 2, t = v === 1 ? 0 : (slot - c) / c, a = Math.abs(t);
    var x = (slot - c) * g.step, s = SMIN + (1 - SMIN) * (1 - a), r = t * ROT;
    var y = a * a * g.h * 0.07 + g.h * 0.10;   // x,y de abanico respecto al centro del escenario
    if (this.hovered >= 0 && this.canHover()) {
      if (slot === this.hovered) { y -= 40; s *= 1.08; } else { x += (slot < this.hovered ? -1 : 1) * g.w * 0.11; }
    }
    return { x: x, y: y, rotation: r, scale: s, zIndex: 10 - Math.round(a * c) };
  };

  // x/y de abanico (origen = centro del escenario, arriba) -> transform relativo a la posicion en el flujo de la fila
  Fan.prototype.relX = function (i, x) { return this.stageW / 2 - this.geo.w / 2 + x - this.baseLeft[i]; };
  Fan.prototype.relY = function (y) { return y - this.baseTop; };
  Fan.prototype.rel = function (i, tg) { return Object.assign({}, tg, { x: this.relX(i, tg.x), y: this.relY(tg.y) }); };

  Fan.prototype.place = function (animate, mode, dir) {
    var self = this, g = this.geo, gsap = window.gsap;
    this.cards.forEach(function (a, i) {
      var slot = self.slotOf(i), vis = slot < g.vis, side = dir < 0 ? -1 : 1;
      var tg = vis ? self.target(slot) : { x: side * g.step * (g.vis / 2 + 2), y: g.h * 0.1, rotation: side * ROT, scale: SMIN, zIndex: 0 };
      tg = self.rel(i, tg);
      var op = vis ? 1 : 0;
      a.classList.toggle('kfan__card--r', vis && slot > (g.vis - 1) / 2);
      a.classList.toggle('kfan__card--c', vis && slot === Math.floor((g.vis - 1) / 2));
      a.style.pointerEvents = vis ? 'auto' : 'none';
      a.tabIndex = vis ? 0 : -1;
      a.setAttribute('aria-hidden', vis ? 'false' : 'true');
      if (!animate || self.reduce()) { gsap.killTweensOf(a); gsap.set(a, Object.assign({ opacity: op }, tg)); a._hid = !vis; return; }
      gsap.killTweensOf(a);
      if (mode === 'hover') { gsap.to(a, Object.assign({ opacity: op, duration: 0.7, ease: 'elastic.out(1,.75)', overwrite: 'auto' }, tg)); return; }
      if (a._hid && vis && mode !== 'snap') gsap.set(a, { x: self.relX(i, -side * g.step * (g.vis / 2 + 2)), opacity: 0, rotation: -side * ROT });
      gsap.to(a, Object.assign({ opacity: op, duration: self.coarse ? 0.3 : 0.8, ease: self.coarse ? 'power3.out' : 'elastic.out(1,.75)', overwrite: 'auto' }, tg));
      a._hid = !vis;
    });
    if (mode !== 'hover') this.keepFocusVisible();
  };

  // si la tarjeta con el foco ha quedado oculta, pasar el foco a la tarjeta centrada
  Fan.prototype.keepFocusVisible = function () {
    var i = this.cards.indexOf(document.activeElement);
    if (i < 0 || this.slotOf(i) < this.geo.vis) return;
    var c = Math.floor((this.geo.vis - 1) / 2), self = this, t = null;
    this.cards.forEach(function (a, k) { if (self.slotOf(k) === c) t = a; });
    if (t) t.focus({ preventScroll: true });
  };

  // la tarjeta sigue al dedo mientras se arrastra (sin animar) y al soltar vuelve o cambia con snap
  Fan.prototype.dragBy = function (dx) {
    var self = this, g = this.geo, k = 0.6;
    this.cards.forEach(function (a, i) {
      var slot = self.slotOf(i); if (slot >= g.vis) return;
      window.gsap.killTweensOf(a);
      window.gsap.set(a, { x: self.rel(i, self.target(slot)).x + dx * k });
    });
  };

  Fan.prototype.intro = function () {
    var self = this, gsap = window.gsap;
    this.place(false);
    if (this.reduce()) return;
    this.cards.forEach(function (a, i) {
      var slot = self.slotOf(i); if (slot >= self.geo.vis) return;
      var tg = self.target(slot);
      gsap.fromTo(a, { opacity: 0, y: self.relY(tg.y + 110), scale: tg.scale * 0.6, rotation: 0, x: self.relX(i, 0) },
        Object.assign({ opacity: 1, duration: self.coarse ? 0.55 : 1.1, delay: slot * (self.coarse ? 0.035 : 0.06), ease: self.coarse ? 'power3.out' : 'elastic.out(1.05,.78)' }, self.rel(i, tg)));
    });
  };

  Fan.prototype.buildUi = function () {
    var self = this;
    if (this.N <= this.geo.vis) { this.ui.classList.remove('kfan__ui--show'); return; }
    this.ui.classList.add('kfan__ui--show');
    this.dots.innerHTML = '';
    for (var i = 0; i < this.N; i++) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kfan__dot'; b.setAttribute('aria-label', 'Ir a ' + (i + 1) + ' de ' + this.N);
      (function (i) { b.addEventListener('click', function () { self.goToProduct(i); }, self.sig); })(i);
      this.dots.appendChild(b);
    }
    this.fitUi();
    this.syncUi();
  };

  // puntos solo si caben: N*44 + 2 flechas*44 + huecos + padding del contenedor
  Fan.prototype.fitUi = function () {
    var need = this.N * 44 + 2 * 48 + 2 * 8 + 32;
    this.ui.classList.toggle('kfan__ui--counter', need > this.root.clientWidth);
  };

  Fan.prototype.center = function () { return (this.offset + Math.floor((this.geo.vis - 1) / 2)) % this.N; };

  Fan.prototype.syncUi = function () {
    var cur = this.center();
    Array.prototype.forEach.call(this.dots.children, function (d, i) { d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
    if (this.count) this.count.textContent = (this.center() + 1) + ' / ' + this.N;
  };

  Fan.prototype.go = function (d) {
    if (this.N <= this.geo.vis || !d) { this.place(true, 'snap'); return; }
    var dir = d > 0 ? 1 : -1;
    this.offset = ((this.offset + d) % this.N + this.N) % this.N;
    this.hovered = -1; this.place(true, 'go', dir); this.syncUi();
    if (this.live) this.live.textContent = (this.center() + 1) + ' de ' + this.N;
  };

  Fan.prototype.enable = function () {
    var self = this;
    try {
      this.root.classList.add('kfan--fan');
      this.measure();
      var c = Math.floor((this.geo.vis - 1) / 2);
      this.offset = this.N > this.geo.vis ? (((3 - c) % this.N) + this.N) % this.N : 0;  // arranca con el 4.o bloque al centro
      window.gsap.set(this.cards, { opacity: 0 });
      this.buildUi();
      this.active = true;
      // eventos
      this.cards.forEach(function (a, i) {
        a.addEventListener('pointerenter', function () {
          if (!self.canHover()) return; var s = self.slotOf(i);
          if (s < self.geo.vis) { self.hovered = s; self.place(true, 'hover'); }
        }, self.sig);
        a.addEventListener('pointerleave', function () { if (!self.canHover()) return; self.hovered = -1; self.place(true, 'hover'); }, self.sig);
        a.addEventListener('click', function (e) { if (self.moved) e.preventDefault(); }, self.sig);
        a.addEventListener('dragstart', function (e) { e.preventDefault(); }, self.sig);
      });
      this.root.querySelector('[data-next]').addEventListener('click', function () { self.go(1); }, this.sig);
      this.root.querySelector('[data-prev]').addEventListener('click', function () { self.go(-1); }, this.sig);
      this.root.addEventListener('keydown', function (e) {
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || self.N <= self.geo.vis) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(-1); }
      }, this.sig);
      // swipe TACTIL con touch events (iOS/Safari fallan con pointer capture): umbral 35 px horizontal, el movimiento horizontal bloquea el scroll vertical
      var sx = 0, sy = 0, tracking = false, decided = false, horiz = false;
      this.stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tracking = false; return; }
        tracking = true; decided = false; horiz = false; self.moved = false; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true, signal: this.ac.signal });
      this.stage.addEventListener('touchmove', function (e) {
        if (!tracking) return;
        var t = e.touches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (!decided && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) { decided = true; horiz = Math.abs(dx) > Math.abs(dy); }
        if (horiz) { self.moved = true; if (e.cancelable) e.preventDefault(); if (!self.reduce()) self.dragBy(dx); }
      }, { passive: false, signal: this.ac.signal });
      this.stage.addEventListener('touchend', function (e) {
        if (!tracking) return; tracking = false;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        self.tEnd = performance.now();
        if (horiz && Math.abs(dx) >= 35 && Math.abs(dx) > Math.abs(dy)) self.go(dx < 0 ? 1 : -1);
        else if (horiz) self.place(true, 'snap');
        setTimeout(function () { self.moved = false; }, 60);
      }, { passive: true, signal: this.ac.signal });
      this.stage.addEventListener('touchcancel', function () { tracking = false; self.moved = false; if (self.active) self.place(true, 'snap'); }, { passive: true, signal: this.ac.signal });
      // arrastre con raton (solo mouse; el tactil va por touch events)
      var mx = 0, my = 0, mdown = false;
      this.stage.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; mdown = true; self.moved = false; mx = e.clientX; my = e.clientY; }, this.sig);
      this.stage.addEventListener('pointermove', function (e) { if (mdown && Math.abs(e.clientX - mx) > 12) self.moved = true; }, this.sig);
      this.stage.addEventListener('pointerup', function (e) {
        if (!mdown) return; mdown = false;
        var dx = e.clientX - mx, dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.go(dx < 0 ? 1 : -1);
        setTimeout(function () { self.moved = false; }, 60);
      }, this.sig);
      this.stage.addEventListener('pointercancel', function () { mdown = false; self.moved = false; }, this.sig);
      // resize y preferencia de movimiento
      var rt, lastW = this.root.clientWidth, lastH = window.innerHeight;
      var relayout = function () {
        clearTimeout(rt);
        rt = setTimeout(function () {
          if (!self.active) return;
          var wNow = self.root.clientWidth, hNow = window.innerHeight;
          if (wNow === lastW && hNow === lastH) return;
          lastW = wNow; lastH = hNow;
          var cProd = self.center();   // mantener centrado el mismo producto al cambiar de ancho
          self.measure();
          self.offset = self.N > self.geo.vis ? (((cProd - Math.floor((self.geo.vis - 1) / 2)) % self.N) + self.N) % self.N : 0;
          self.place(false); self.buildUi();
        }, 100);
      };
      if ('ResizeObserver' in window) { this.ro = new ResizeObserver(relayout); this.ro.observe(this.root); }
      window.addEventListener('resize', relayout, this.sig);   // alto de ventana (ajuste 70vh)
      var onMotion = function () { if (self.active) { window.gsap.killTweensOf(self.cards); self.place(false); } };
      if (this.mqReduce.addEventListener) { this.mqReduce.addEventListener('change', onMotion, this.sig); this.mqHover.addEventListener('change', onMotion, this.sig); }
      // entrada al hacerse visible
      var start = function () { if (self.started || self.destroyed) return; self.started = true; self.intro(); };
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { start(); self.io.disconnect(); } }, { threshold: 0.15 });
        this.io.observe(this.stage);
        this.t = setTimeout(start, 1500);
      } else { start(); }
    } catch (err) {
      this.fallback();
    }
  };

  Fan.prototype.fallback = function () { this.teardown(); };

  Fan.prototype.teardown = function () {
    this.active = false;
    this.ac.abort();
    clearTimeout(this.t);
    if (this.io) this.io.disconnect();
    if (this.ro) this.ro.disconnect();
    if (this.nearIo) this.nearIo.disconnect();
    if (window.gsap) window.gsap.killTweensOf(this.cards);
    this.root.classList.remove('kfan--fan');
    this.cards.forEach(function (a) { a.removeAttribute('style'); a.removeAttribute('aria-hidden'); a.removeAttribute('tabindex'); });
    this.stage.style.height = '';
    if (this.ui) this.ui.classList.remove('kfan__ui--show');
  };

  Fan.prototype.destroy = function () { this.destroyed = true; this.teardown(); };

  // centra el producto i (camino mas corto)
  Fan.prototype.goToProduct = function (i) {
    if (!this.active || this.N <= this.geo.vis) return;
    var want = ((i - Math.floor((this.geo.vis - 1) / 2)) % this.N + this.N) % this.N;
    var d = want - this.offset; if (d > this.N / 2) d -= this.N; if (d < -this.N / 2) d += this.N;
    this.go(d);
  };

  Fan.prototype.reveal = function (card) {
    var i = this.cards.indexOf(card); if (i >= 0) this.goToProduct(i);
  };

  function init(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new Fan(root));
  }
  function destroy(root) {
    var f = root && instances.get(root);
    if (f) { f.destroy(); instances.delete(root); }
  }
  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-kfan]'), init);
  }

  window.KnockoutAbanico = { init: init, destroy: destroy, initAll: initAll };

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-kfan]'), destroy);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-kfan]'); var f = root && instances.get(root);
    var card = e.target.matches && e.target.matches('[data-kfan-card]') ? e.target : e.target.querySelector && e.target.querySelector('[data-kfan-card]');
    if (f && card) f.reveal(card);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
